import { render, staticRenderFns } from "./projectAdvantageWidge.vue?vue&type=template&id=5aa1a783&scoped=true"
import script from "./projectAdvantageWidge.vue?vue&type=script&lang=js"
export * from "./projectAdvantageWidge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa1a783",
  null
  
)

export default component.exports